'use client';
import React, { useState } from 'react';
import { Download, ChevronDown, ChevronUp } from 'lucide-react';
import { toast } from 'sonner';

const TRANSACTIONS = [
  { id: 'inv-2026-006', date: 'Jun 22, 2026', description: 'Premium Membership — Annual', amount: '$49.95', status: 'paid', invoice: 'INV-2026-006' },
  { id: 'inv-2026-005', date: 'Jun 22, 2026', description: 'Storage Pack (+100 Photos)', amount: '$19.95', status: 'paid', invoice: 'INV-2026-005' },
  { id: 'inv-2025-004', date: 'Jun 22, 2025', description: 'Premium Membership — Annual', amount: '$49.95', status: 'paid', invoice: 'INV-2025-004' },
  { id: 'inv-2025-003', date: 'Mar 15, 2025', description: 'Storage Pack (+100 Photos)', amount: '$19.95', status: 'paid', invoice: 'INV-2025-003' },
  { id: 'inv-2024-002', date: 'Jun 22, 2024', description: 'Premium Membership — Annual', amount: '$49.95', status: 'paid', invoice: 'INV-2024-002' },
  { id: 'inv-2024-001', date: 'Jan 5, 2024', description: 'Storage Pack (+100 Photos)', amount: '$19.95', status: 'paid', invoice: 'INV-2024-001' },
];

const STATUS_STYLES: Record<string, string> = {
  paid: 'bg-green-50 text-green-700 border-green-200',
  pending: 'bg-yellow-50 text-yellow-700 border-yellow-200',
  failed: 'bg-red-50 text-red-700 border-red-200',
};

export default function BillingHistory() {
  const [showAll, setShowAll] = useState(false);
  const visible = showAll ? TRANSACTIONS : TRANSACTIONS.slice(0, 4);

  return (
    <div className="bg-card border border-border rounded-2xl shadow-card overflow-hidden">
      <div className="flex items-center justify-between px-6 py-4 border-b border-border">
        <h3 className="font-700 text-sm text-foreground">Billing History</h3>
        <span className="text-xs text-muted-foreground">{TRANSACTIONS.length} transactions</span>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-border bg-muted/40">
              <th className="text-left px-6 py-3 text-xs font-600 text-muted-foreground">Invoice</th>
              <th className="text-left px-4 py-3 text-xs font-600 text-muted-foreground">Date</th>
              <th className="text-left px-4 py-3 text-xs font-600 text-muted-foreground">Description</th>
              <th className="text-right px-4 py-3 text-xs font-600 text-muted-foreground">Amount</th>
              <th className="text-center px-4 py-3 text-xs font-600 text-muted-foreground">Status</th>
              <th className="text-center px-6 py-3 text-xs font-600 text-muted-foreground">Download</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {visible.map((tx) => (
              <tr key={tx.id} className="hover:bg-muted/30 transition-colors">
                <td className="px-6 py-4 text-xs font-600 text-muted-foreground font-tabular">{tx.invoice}</td>
                <td className="px-4 py-4 text-sm text-foreground whitespace-nowrap">{tx.date}</td>
                <td className="px-4 py-4 text-sm text-foreground">{tx.description}</td>
                <td className="px-4 py-4 text-sm font-700 text-foreground text-right font-tabular">{tx.amount}</td>
                <td className="px-4 py-4 text-center">
                  <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-600 border ${STATUS_STYLES[tx.status]}`}>
                    {tx.status}
                  </span>
                </td>
                <td className="px-6 py-4 text-center">
                  <button
                    onClick={() => toast.success(`Downloading ${tx.invoice}...`)}
                    className="w-7 h-7 rounded-lg bg-muted flex items-center justify-center text-muted-foreground hover:text-primary hover:bg-secondary transition-colors mx-auto"
                    title={`Download invoice ${tx.invoice}`}
                  >
                    <Download size={13} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {TRANSACTIONS.length > 4 && (
        <div className="px-6 py-3 border-t border-border">
          <button
            onClick={() => setShowAll(v => !v)}
            className="flex items-center gap-1.5 text-xs font-600 text-primary hover:underline"
          >
            {showAll ? <><ChevronUp size={13} />Show less</> : <><ChevronDown size={13} />Show all {TRANSACTIONS.length} transactions</>}
          </button>
        </div>
      )}
    </div>
  );
}